import { useSearchParams } from 'react-router-dom';
import { Footer, TitleBar } from '../../../components';
import TitleUpdater from '../../../components/common/TitleUpdater';
import { useLocationName } from '../../../hooks';
import TableV3 from '../../../components/generic/Table/TableV3';
import { columns } from '../columns/columns';
import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { GET_PROCESS_AREA } from '../../cyber/location-applications';
import QueryErrorBoundary from '../../../components/error-handling';
import { useProcessAreasItApplications } from '../hooks/useProcessAreasItApplications';

type ProcessAreaData = {
  findProcessAreaByUuid: {
    processArea: string;
  };
};

export const CyberHubProcessAreasItApplications = () => {
  let [searchParams] = useSearchParams();
  const locationId = searchParams.get('locationId')!;
  const processAreaId = searchParams.get('processAreaId')!;

  const { locationName } = useLocationName(locationId);

  const [processAreaName, setProcessAreaName] = useState<string>('');

  const { error: processAreaError } = useQuery<ProcessAreaData>(
    GET_PROCESS_AREA,
    {
      variables: {
        uuid: processAreaId,
      },
      onCompleted: (data) =>
        setProcessAreaName(data.findProcessAreaByUuid.processArea),
    },
  );

  const { data, loading } = useProcessAreasItApplications(
    processAreaId,
    locationId,
  );

  const pageTitle = locationName
    ? `${locationName} - Process Area Applications`
    : 'Process Area Applications';

  const title = locationName
    ? `${locationName} - Process Area Applications`
    : 'Process Area Applications';

  return (
    <div>
      <TitleUpdater title={pageTitle} />
      <QueryErrorBoundary error={processAreaError}>
        <TitleBar title={title} subtitle={processAreaName} />
      </QueryErrorBoundary>
      <TableV3
        title="Applications"
        data={data?.itApplications}
        columns={columns}
        loading={loading}
      />
      <Footer goBack />
    </div>
  );
};
